module.exports = `${require.publicPath}405.a0491000.png`;